import Refinery from '@/models/Refinery'
import User, { hasRole, Role } from '@/models/User'

export default class RefineryPolicy {
    viewAny(_user: User): boolean {
        return true
    }

    view(user: User, refinery: Refinery) {
        switch (user.role) {
            case Role.USER:
                return user.company?.id === refinery.entry.catalog.company.id
            case Role.AUDITOR:
                return refinery.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.USER)
    }

    update(user: User, refinery: Refinery) {
        return hasRole(user, Role.USER) && user.company?.id === refinery.entry.catalog.company.id
    }

    restore(user: User, refinery: Refinery) {
        return hasRole(user, Role.USER) && user.company?.id === refinery.entry.catalog.company.id
    }

    delete(user: User, refinery: Refinery) {
        return hasRole(user, Role.USER) && user.company?.id === refinery.entry.catalog.company.id
    }

    forceDelete(_user: User, _refinery: Refinery) {
        return false
    }
}
